export default __webpack_public_path__ + "static/media/geko.32bf4fca.svg";